/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots.common || ($protobuf.roots.common = new $protobuf.Root()))
.addJSON({
  ussRpc: {
    options: {
      go_package: "./ussRpc"
    },
    nested: {
      SendCodeSMSRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          tplCode: {
            type: "string",
            id: 2
          },
          signName: {
            type: "string",
            id: 3
          }
        }
      },
      SendCodeSMSResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSSendSMSCodeRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          }
        }
      },
      USSSendSMSCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSPhoneSignInRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          source: {
            type: "RegistrySource",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 5
          }
        }
      },
      USSPhoneSignInResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          },
          isNewUser: {
            type: "bool",
            id: 5
          }
        }
      },
      USSThirdPartyLoginRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          openId: {
            type: "string",
            id: 2
          },
          accessToken: {
            type: "string",
            id: 3
          },
          source: {
            type: "RegistrySource",
            id: 4
          },
          businessId: {
            type: "string",
            id: 5
          }
        }
      },
      USSThirdPartyLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          }
        }
      },
      USSMiniAppLoginRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          },
          source: {
            type: "RegistrySource",
            id: 3
          }
        }
      },
      USSMiniAppLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          },
          openId: {
            type: "string",
            id: 5
          }
        }
      },
      USSBindMiniAppPhoneRequest: {
        fields: {
          encryptedData: {
            type: "string",
            id: 1
          },
          iv: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 5
          }
        }
      },
      USSBindMiniAppPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          }
        }
      },
      USSMiniAppPhoneLoginRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          },
          source: {
            type: "RegistrySource",
            id: 3
          },
          encryptedData: {
            type: "string",
            id: 4
          },
          iv: {
            type: "string",
            id: 5
          },
          businessId: {
            type: "string",
            id: 6
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 7
          }
        }
      },
      USSMiniAppPhoneLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          },
          isNewUser: {
            type: "bool",
            id: 5
          }
        }
      },
      USSBindUserPhoneRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          }
        }
      },
      USSBindUserPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userId: {
            type: "string",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          user: {
            type: "UserInfo",
            id: 5
          }
        }
      },
      USSChangeUserPhoneRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          }
        }
      },
      USSChangeUserPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSAccountLogoutRequest: {
        fields: {}
      },
      USSAccountLogoutResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UserInfo: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          sex: {
            type: "string",
            id: 3
          },
          avatarHDImg: {
            type: "string",
            id: 4
          },
          weiboID: {
            type: "string",
            id: 5
          },
          wechatID: {
            type: "string",
            id: 6
          },
          appleID: {
            type: "string",
            id: 7
          },
          userId: {
            type: "string",
            id: 8
          },
          uid: {
            type: "int32",
            id: 9
          }
        }
      },
      UserAddress: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          },
          recipient: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          province: {
            type: "string",
            id: 4
          },
          city: {
            type: "string",
            id: 5
          },
          regions: {
            type: "string",
            id: 6
          },
          detailAddress: {
            type: "string",
            id: 7
          },
          isDefault: {
            type: "bool",
            id: 8
          }
        }
      },
      FromAdvertisement: {
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          idfa: {
            type: "string",
            id: 2
          },
          channel: {
            type: "AdvertisingChannels",
            id: 3
          },
          advertId: {
            type: "string",
            id: 4
          }
        }
      },
      LoginType: {
        values: {
          UnKnownType: 0,
          Phone: 1,
          WeiXin: 2,
          WXMiniApp: 3,
          AppleID: 4,
          OneClickLogin: 5,
          LoginTypeBaiDuMiniApp: 6,
          LoginTypeByteDanceMiniApp: 7,
          LoginTypeALiPayMiniApp: 8,
          LoginTypeKSMiniApp: 9
        }
      },
      RegistrySource: {
        values: {
          UnKnownSource: 0,
          WAWSisterActivity: 1,
          AppraisalPullNew: 2,
          SeventhMoon: 3,
          OnlyTow: 4,
          ProductSplit: 5,
          CloudStorage: 6,
          BaoGo: 7
        }
      },
      WalletRunningCountTypeEnum: {
        values: {
          All: 0,
          Income: 1,
          Withdraw: 2,
          EARecycle: 3,
          Consign: 4,
          ConsignAdvancePayment: 5,
          Exchange: 6,
          CloudStorageBuy: 7,
          LotteryCash: 8
        }
      },
      AdvertisingChannels: {
        values: {
          UnKnown: 0,
          ByteDanceChannel: 1,
          GDTChannel: 2,
          KSChannel: 3
        }
      },
      USSSaveAddressRequest: {
        fields: {
          userAddress: {
            type: "UserAddress",
            id: 1
          }
        }
      },
      USSSaveAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSDelAddressRequest: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          }
        }
      },
      USSDelAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSAddressListRequest: {
        fields: {}
      },
      USSAddressListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          addrList: {
            rule: "repeated",
            type: "UserAddress",
            id: 3
          }
        }
      },
      USSSetDefaultAddressRequest: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          }
        }
      },
      USSSetDefaultAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      GetAddressByIdRequest: {
        fields: {
          addrId: {
            type: "string",
            id: 1
          }
        }
      },
      GetAddressByIdResponse: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          },
          recipient: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          province: {
            type: "string",
            id: 4
          },
          city: {
            type: "string",
            id: 5
          },
          regions: {
            type: "string",
            id: 6
          },
          detailAddress: {
            type: "string",
            id: 7
          },
          isDefault: {
            type: "bool",
            id: 8
          }
        }
      },
      UssThirdPartyLoginEnableRequest: {
        fields: {
          clientId: {
            type: "string",
            id: 1
          }
        }
      },
      UssThirdPartyLoginEnableResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          }
        }
      },
      TSByteDanceEventType: {
        values: {
          EventType_Default: 0,
          EventType_Activate: 1,
          EventType_Register: 2
        }
      },
      TSByteDanceADCallBackRequest: {
        fields: {
          os: {
            type: "string",
            id: 1
          },
          csite: {
            type: "string",
            id: 2
          },
          IMEI: {
            type: "string",
            id: 3
          },
          IDFA: {
            type: "string",
            id: 4
          },
          AndroidId: {
            type: "string",
            id: 5
          },
          UA: {
            type: "string",
            id: 6
          },
          Mac: {
            type: "string",
            id: 7
          },
          IP: {
            type: "string",
            id: 8
          },
          Geo: {
            type: "string",
            id: 9
          },
          eventType: {
            type: "TSByteDanceEventType",
            id: 10
          }
        }
      },
      TSByteDanceADCallBackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UssRpc: {
        methods: {
          SendSmsCode: {
            requestType: "SendCodeSMSRequest",
            responseType: "SendCodeSMSResponse"
          },
          PhoneLogin: {
            requestType: "USSPhoneSignInRequest",
            responseType: "USSPhoneSignInResponse"
          },
          ThirdPartyLogin: {
            requestType: "USSThirdPartyLoginRequest",
            responseType: "USSThirdPartyLoginResponse"
          },
          MiniAppLogin: {
            requestType: "USSMiniAppLoginRequest",
            responseType: "USSMiniAppLoginResponse"
          },
          BindMiniAppPhone: {
            requestType: "USSBindMiniAppPhoneRequest",
            responseType: "USSBindMiniAppPhoneResponse"
          },
          MiniAppPhoneLogin: {
            requestType: "USSMiniAppPhoneLoginRequest",
            responseType: "USSMiniAppPhoneLoginResponse"
          },
          BindPhone: {
            requestType: "USSBindUserPhoneRequest",
            responseType: "USSBindUserPhoneResponse"
          },
          AuthByToken: {
            requestType: "AuthByTokenRequest",
            responseType: "AuthByTokenResponse"
          },
          GetUserById: {
            requestType: "GetUserByIdRequest",
            responseType: "GetUserByIdResponse"
          },
          GetUserByPhone: {
            requestType: "GetUserByPhoneRequest",
            responseType: "GetUserByPhoneResponse"
          },
          GetAddressById: {
            requestType: "GetAddressByIdRequest",
            responseType: "GetAddressByIdResponse"
          },
          EnterMoneyToWallet: {
            requestType: "EnterMoneyToWalletRequest",
            responseType: "EnterMoneyToWalletResponse"
          },
          EnterMoneySuccess: {
            requestType: "EnterMoneySuccessRequest",
            responseType: "EnterMoneySuccessResponse"
          },
          EnterMoneyFail: {
            requestType: "EnterMoneyFailRequest",
            responseType: "EnterMoneyFailResponse"
          }
        }
      },
      AuthByTokenRequest: {
        fields: {
          token: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      AuthByTokenResponse: {
        fields: {
          user: {
            type: "UserInfo",
            id: 1
          }
        }
      },
      GetUserByIdRequest: {
        fields: {
          uid: {
            type: "string",
            id: 1
          },
          noCache: {
            type: "bool",
            id: 2
          }
        }
      },
      GetUserByIdResponse: {
        fields: {
          user: {
            type: "UserInfo",
            id: 1
          }
        }
      },
      GetUserByPhoneRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          noCache: {
            type: "bool",
            id: 2
          }
        }
      },
      GetUserByPhoneResponse: {
        fields: {
          user: {
            type: "UserInfo",
            id: 1
          }
        }
      },
      USSUserWalletInfoRequest: {
        fields: {}
      },
      USSUserWalletInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          balance: {
            type: "int32",
            id: 3
          },
          alipayAccount: {
            type: "string",
            id: 4
          },
          singleDayWithdrawMax: {
            type: "int32",
            id: 5
          },
          singleDayWithdrawRest: {
            type: "int32",
            id: 6
          },
          isAlipayAccountBound: {
            type: "bool",
            id: 7
          }
        }
      },
      USSWalletBindALiPayAccountRequest: {
        fields: {
          alipayAccount: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      USSWalletBindALiPayAccountResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSWalletFlowListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          dateMonth: {
            type: "string",
            id: 3
          },
          flowType: {
            type: "WalletRunningCountTypeEnum",
            id: 4
          }
        }
      },
      USSWalletFlowListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          flowList: {
            rule: "repeated",
            type: "Flow",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          Flow: {
            fields: {
              flowType: {
                type: "WalletRunningCountTypeEnum",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              dateTime: {
                type: "string",
                id: 3
              },
              amount: {
                type: "int32",
                id: 4
              },
              orderID: {
                type: "string",
                id: 5
              },
              reportID: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      USSWalletWithdrawSMSRequest: {
        fields: {
          token: {
            type: "string",
            id: 1
          },
          amount: {
            type: "int32",
            id: 2
          }
        }
      },
      USSWalletWithdrawSMSResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      USSWalletWithdrawRequest: {
        fields: {
          token: {
            type: "string",
            id: 1
          },
          amount: {
            type: "int32",
            id: 2
          }
        }
      },
      USSWalletWithdrawResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      EnterMoneyToWalletRequest: {
        fields: {
          uid: {
            type: "int32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          enterAmount: {
            type: "int32",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          event: {
            type: "WalletRunningCountTypeEnum",
            id: 6
          }
        }
      },
      EnterMoneyToWalletResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          flowId: {
            type: "string",
            id: 3
          }
        }
      },
      EnterMoneySuccessRequest: {
        fields: {
          flowId: {
            type: "string",
            id: 1
          }
        }
      },
      EnterMoneySuccessResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      EnterMoneyFailRequest: {
        fields: {
          flowId: {
            type: "string",
            id: 1
          }
        }
      },
      EnterMoneyFailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      }
    }
  }
});

export { $root as default };
